module.exports = __webpack_public_path__ + "static/img/noData.6db599c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noData.png
// module id = cABt
// module chunks = 45